import { Backdrop, CircularProgress } from '@mui/material';

interface Props {
  backdrop?: boolean;
}
export const Loader = (props: Props) => {
  let backdropValue = props.backdrop ?? true;
  return backdropValue ? (
    <Backdrop open style={{ zIndex: 2000 }}>
      <CircularProgress color="primary" />
    </Backdrop>
  ) : (
    <CircularProgress color="primary" />
  );
};

export default Loader;
